<template>
    <main class="app-content">
        <div class="container">
            <header class="pg-header">
                <h1>Notifications</h1>
                <input type="search" name="" v-model="search" value="" placeholder="Search" class="form-control"/>
            </header>
            <section class="notifications-list">
                <template v-if="filteredNotifications !== null">
                    <ol>
                        <li v-for="notification in filteredNotifications">
                    <span class="notication-content">
                        <span class="user-id activities" v-bind:class="{'client-icon': notification.activity.isClientUser}">
                            <span v-if="notification.activity.context">{{ notification.activity.context.byUserInitials }}</span>
                        </span>
                        {{notification.activity.message}}
                    </span>
                            <!--                        <span v-html="notification.activity.message"></span>-->
                            {{ notification.activity.createdAt | formatDate('DD/MM/YYYY HH:MM')}}
                        </li>
                    </ol>
                </template>
                <br>
                <div class="btn-container" style="text-align: center">
                    <button class="btn-primary btn" @click="getNotifications()" v-if="loadMore">Load more</button>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
    import { refreshPageMixin } from '../mixins/refreshPage';
    import NotificationServices from '../services/notifications';

    export default {
        mixins: [refreshPageMixin],
        name: 'Notifications',
        components: {},
        data () {
            return {
                search: '',
                newNotifications: [],
                loadMore: true,
                cursor: 0
            }
        },
        computed: {
            filteredNotifications: function() {
                return this.newNotifications.filter((notification) => {
                    return notification.activity.message.toLowerCase().match(this.search.toLowerCase());
                });
            }
        },
        methods: {
            getNotifications() {
                let vue = this;
                NotificationServices.getActivities(this.cursor).then(activities => {
                    this.cursor += 10;
                    activities.data.forEach(function(notification) {
                        vue.newNotifications.push(notification);
                    });
                    if (typeof activities.meta.cursor.next == 'undefined') {
                        vue.loadMore = false;
                    }
                    NotificationServices.updateIsReadActivities();
                });
            }
        },
        watch: {
            hashChanged(newVal) {
                if (newVal) {
                    this.getNotifications();
                }
            }
        },
        mounted() {
            this.getNotifications();
        }
    }
</script>
